import { PlanType } from '../../types/planType'

export function deserializePlanTypeQueryParam(
  value: string | undefined | null
): PlanType | undefined {
  switch (value?.toUpperCase()) {
    case 'FREE':
    case 'BASIC':
      return PlanType.FREE
    case 'PRO':
      return PlanType.PRO
    case 'PRO+':
    case 'PRO_PLUS':
    case 'PRO+ORG':
    case 'PRO_PLUS_ORG':
      return PlanType.PRO_PLUS_ORG
    case 'PRO_FLEX':
    case 'GROWTH':
      return PlanType.PRO_FLEX
    case 'PILOT':
    case 'TRIAL':
      return PlanType.PILOT
    case 'ENTERPRISE':
      return PlanType.ENTERPRISE
  }
}
